import { InfoCircle } from "@untitledui/icons";
import { useAssuranceOverviewV2 } from "@/api/assurance/assurance-overview";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { Link } from "@/components/link";
import { Skeleton } from "@/components/ui/skeleton";
import { useScopedUrl } from "@/hooks/use-scoped-url";
import { getStartDateISO } from "@/utils/date-conversion";

// Same startDate as NeedsAttentionCard's fixed 30-day window (both are current-state
// fields, dateRange-agnostic server-side) so TanStack Query dedupes the request
// instead of firing a second identical call
const MONITORED_RISKS_WINDOW_DAYS = 30;

export const MonitoringBadge = () => {
  const { data, isLoading } = useAssuranceOverviewV2({ startDate: getStartDateISO(MONITORED_RISKS_WINDOW_DAYS) });
  const scopedUrl = useScopedUrl();

  if (isLoading || !data) {
    return <Skeleton className="h-[30px] w-[160px] rounded-full shrink-0" />;
  }

  return (
    <Link
      to={`${scopedUrl}/configure-safety` as string}
      className="flex items-center gap-1.5 bg-white rounded-full pl-2.5 pr-3 py-1 shrink-0 cursor-pointer"
    >
      <span className="size-3 rounded-full bg-success-500" />
      <p className="text-sm text-success-700 whitespace-nowrap">Monitoring {data.monitoredRisksCount} risks</p>
      <Tooltip title="Live count of risks currently being monitored.">
        <TooltipTrigger className="inline">
          <InfoCircle className="size-4 text-success-700" />
        </TooltipTrigger>
      </Tooltip>
    </Link>
  );
};
